export type Master = "on" | "mentions" | "off";

export type Loudness = "soft" | "normal" | "loud";

export type SoundSettings = {
  master: Master;

  calls: boolean;
  loudness: Loudness;
};

export const MASTERS: readonly Master[] = ["on", "mentions", "off"];
export const LOUDNESSES: readonly Loudness[] = ["soft", "normal", "loud"];

export const BY_DEFAULT: SoundSettings = { master: "on", calls: true, loudness: "normal" };

export const LOUDNESS: Record<Loudness, number> = { soft: 0.35, normal: 0.7, loud: 1 };

const UNDER = "rally-sound:";

function store(): Storage | null {
  try {
    return typeof localStorage === "undefined" ? null : localStorage;
  } catch {
    return null;
  }
}

export function settingsFrom(raw: string | null): SoundSettings | null {
  if (!raw) return null;
  try {
    const held = JSON.parse(raw) as Partial<SoundSettings>;
    const master = MASTERS.includes(held.master as Master) ? (held.master as Master) : BY_DEFAULT.master;
    const loudness = LOUDNESSES.includes(held.loudness as Loudness)
      ? (held.loudness as Loudness)
      : BY_DEFAULT.loudness;
    return { master, calls: held.calls !== false, loudness };
  } catch {
    return null;
  }
}

export function soundSettingsFor(account: string): SoundSettings | null {
  try {
    return settingsFrom(store()?.getItem(UNDER + account) ?? null);
  } catch {
    return null;
  }
}

export function keepSoundSettings(account: string, settings: SoundSettings): void {
  try {
    store()?.setItem(UNDER + account, JSON.stringify(settings));
  } catch {}
}

export function inForce(said: SoundSettings | null, reduced: boolean): SoundSettings {
  if (said) return said;
  return reduced ? { ...BY_DEFAULT, master: "off" } : BY_DEFAULT;
}

export const loudnessOf = (settings: SoundSettings): number => LOUDNESS[settings.loudness];
